import { createContext } from "react";

/**
 * The telemetry surface (`data-surface` name) the current subtree renders in, provided by
 * `ModalShell` / `OverlayPanel` when they get a `surface` prop. `CloseButton` and
 * `DrawerHelpToggle` derive their `data-ui` ids from it (lib/telemetry/instrument.ts
 * `primitiveUiId`). Null outside a tagged surface.
 */
export const SurfaceContext = createContext(null);
